'use client'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { TracedLink } from './TracedLink'
import { useAuth } from '@/providers/auth-provider'
import { ThemeChooser } from '@/components/theme-chooser'
import { UserNotificationComponent } from './user-notification'

export function UserNav() {
  const { user } = useAuth()

  if (!user) {
    return (
      <>
        <Button variant="ghost" size="sm" asChild>
          <TracedLink href="/auth/signin">התחבר</TracedLink>
        </Button>
        <ThemeChooser />
      </>
    )
  }

  const userInitial = user.name?.charAt(0) || user.email?.charAt(0) || 'U'

  return (
    <>
      <UserNotificationComponent />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="relative h-8 w-8 rounded-full">
            <Avatar className="h-8 w-8">
              <AvatarFallback>{userInitial}</AvatarFallback>
            </Avatar>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" align="end" forceMount>
          <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium leading-none" data-private>
                {user.name}
              </p>
              <p className="text-xs leading-none text-muted-foreground" data-private>
                {user.email}
              </p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem asChild>
              <TracedLink href="/account">החשבון שלי</TracedLink>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <DropdownMenuLabel>
                <ThemeChooser />
                <span className="text-right">בחר ערכת נושא</span>
              </DropdownMenuLabel>
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <TracedLink href="/auth/logout">התנתק</TracedLink>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
